export default "__VITE_ASSET__7Nj1jxPa__"